import "../../styles/payroll.css";

const SalarySearchTable = ({
  setSelectedCompany,
  setSalaryMonth,
  setSalaryYear,
  setCompanyId,
  setDepartmentId,
  companyList,
  departmentList = [],
  handleSearch,
  searchQuery,
  setSearchQuery,
}) => {
  const handleCompanyChange = (event) => {
    const selectedCompanyName = event.target.value;
    const selectedCompany = companyList.find(
      (company) => company.company_name === selectedCompanyName
    );
    const selectedCompanyId = selectedCompany ? selectedCompany.id : null;
    setCompanyId(selectedCompanyId);
    setSelectedCompany(selectedCompanyName);
  };

  // const handleDepartmentChange = (event) => {
  //   const selectedDepartmentName = event.target.value;
  //   const selectedDepartment = departmentList.find(
  //     (department) => department.department_name === selectedDepartmentName
  //   );
  //   const selectedDepartmentId = selectedDepartment
  //     ? selectedDepartment.id
  //     : null;
  //   setDepartmentId(selectedDepartmentId);
  // };

  const handleMonthYearChange = (event) => {
    const selectedDate = event.target.value;
    const [year, month] = selectedDate.split("-");

    const date = new Date(`${year}-${month}-01`);
    const monthName = new Intl.DateTimeFormat("en-US", {
      month: "long",
    }).format(date);

    setSalaryMonth(monthName);
    setSalaryYear(year);
  };

  return (
    <div className="grid grid-cols-4 items-center gap-4 justify-between mb-4">
      <div className="">
        <label>All Companies</label>
        <select
          name="company"
          id="company"
          onChange={(event) => handleCompanyChange(event)}
        >
          <option value="">Select Company</option>
          {companyList.map((company) => (
            <option key={company.id} value={company.company_name}>
              {company.company_name}
            </option>
          ))}
        </select>
      </div>

      <div className="">
        <label>Month & Year</label>
        <input
          type="month"
          name="salary_date"
          onChange={(event) => handleMonthYearChange(event)}
        />
      </div>
      <div className="mt-9">
        <button
          className="bg-theme-color text-white py-2.5 px-4 rounded-md"
          onClick={handleSearch}
        >
          <i className="ri-search-line"></i>
        </button>
      </div>
      <div className="relative mt-9">
        <input
          type="text"
          className="!rounded-3xl !uppercase text-center"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <span className="absolute top-3 right-4 text-gray-400">
          <i className="ri-search-line"></i>
        </span>
      </div>
    </div>
  );
};

export default SalarySearchTable;
